import { type ReviewsList } from '@/features/reviews/types/reviews-types';

export const REVIEWS: ReviewsList = {
  apartments: [
    {
      date: '2023-08-26',
      description: 'Your companion for any residential search process. Even though I work in the tech industry, I am not a big fan of downloading additional.apps on my phone. I can come up with a number of "downsidesrelated to downloading apps unnecessarily. Roomser, on the other hand, was a welcome addition to my app library and comes with tremendous value. Roomser offers a variety of features that will make it possible to laser target search for your next dream housing solution. I recommend Roomster with 5 star',
      gender: 'male',
      id: 'c2260b59-cfc0-4ec9-ab55-f7e153a8b9b7',
      location: 'San Francisco',
      name: 'Jovanny83',
      rating: 5,
      title: 'Powerful app for finding dream homes',
    },
    {
      date: '2019-04-01',
      description: 'It\'s decent. I\'m looking to sublet my apartment.',
      gender: 'female',
      id: '874ab4ff-698e-4669-a761-8f6c3e59ce6c',
      location: 'Miami',
      name: 'Alexandra R.',
      rating: 5,
      title: 'Roomster is a great app',
    },
  ],
  roommate: [
    {
      date: '2024-10-29',
      description: 'So far I have received contact from 2 renters and 2 possible roommates. since this is my first few days on the app. Id say it\'s going quite well. The app is very user friendly the prices are a bit high if you end up looking for a long time. So I suggest making it a quick but informed decision and making the best of what you can find.',
      gender: 'male',
      id: 'ce128c2e-a1c5-434b-94d3-a40b67910606',
      location: 'New York',
      name: 'Kevin C.',
      rating: 5,
      title: 'Easy to Use App',
    },
    {
      date: '2022-11-01',
      description: 'Made the process of connecting me with potential roommates much easier. Before I was relying on word of mouth from friends. Roomster brings everyone together in one simple to use app. And you get the bonus of scene the room in pictures before having to make an appointment to go see it in person. So now what either never came together or I had to spend a whole afternoon working on I can do from the ease of home or office at any time I do think the best feature is the pictures that you get to see',
      gender: 'female',
      id: '8f45c6f3-f8d8-47f1-b6ac-211b8aabf171',
      location: 'Texas',
      name: 'Katelyn H.',
      rating: 5,
      title: 'Found roommates faster than ever',
    },
  ],
  rooms: [
    {
      date: '2025-09-21',
      description: 'I used this app last year and was able to find a place within a week. Definitely going to try it again when i have to move!',
      gender: 'female',
      id: 'ab404595-551d-449c-9a11-1e09c2001dc3',
      location: 'Los Angeles',
      name: 'Colette J.',
      rating: 5,
      title: 'Found a great place within a week',
    },
    {
      date: '2023-05-17',
      description: 'Roomster has been very helpful to me in my search of a room for rent since I am new to the area!',
      gender: 'male',
      id: 'a1001f69-8211-4531-9cf5-54806df2cf20',
      location: 'Boston',
      name: 'Brandon W.',
      rating: 5,
      title: 'Helpful tool for finding a room fast',
    },
    {
      date: '2022-01-16',
      description: 'Roomster is one of several apps that provide a much accessible way to find new living arrangements. I\'ve used this app several times in the past; over two different states and have been successful with finding suitable living accommodations. I would recommend this app to anyone looking for a place whether short or long-term.',
      gender: 'female',
      id: 'a1001f69-8211-4531-9cf5-54806df2bnm7',
      location: 'Boston',
      name: 'Marry K.',
      rating: 5,
      title: 'Reliable app for finding rooms anywhere',
    },
  ],
  tenants: [
    {
      date: '2023-09-22',
      description: 'I paid for 2 weeks and interviewed tenant. As far as I can tell the app works well. Just wish message notifications were better. Easy to unsubscibe and delete listing once the room is rented! I find it to be a great app and worth the money. Will use again. Be aware the 2nd week billing was charged very close (within minutes) to same time and day initially charged. Honorable transaction.',
      gender: 'female',
      id: 'ab404595-551d-449c-9a11-1e09c2006wy7',
      location: 'Chicago',
      name: 'Claudia T.',
      rating: 5,
      title: 'Easy to manage listings and payments',
    },
    {
      date: '2021-03-19',
      description: 'Great app for finding tenants. Great app, would recommend',
      gender: 'male',
      id: 'ab404595-551d-449c-9a11-1e09c20bv413',
      location: 'Houston',
      name: 'Moris W.',
      rating: 5,
      title: 'Great app',
    },
    {
      date: '2019-07-12',
      description: 'It’s a great app. I am talking to and interviewing tenants every day. There are so many professional individuals to choose from. I know the tenant I finally choose will be the best. Thx Roomster.',
      gender: 'female',
      id: 'ab404595-551d-449c-9a11-1e09c200990C',
      location: 'Houston',
      name: 'Jenny S.',
      rating: 5,
      title: 'Great app',
    },
  ],
} as const;
